export default "__VITE_ASSET__BWMp_p4t__"